import axios from 'axios';
import _ from 'lodash';

export const getProviderList = () => {
  return axios.get('/cms/provider/list').then((res) => {
    if (res.data.code === 0) {
      return _.get(res, 'data.data.providers', []);
    }
  });
};

export const getProviderCategoryList = () => {
  return axios.get('/cms/game/category/list').then((res) => {
    if (res.data.code === 0) {
      return _.get(res, 'data.data', []);
    }
  });
};

export const getProviderListByCategoryName = (categoryCode) => {
  return axios
    .get('/cms/provider/list', {
      params: { category_name: categoryCode },
    })
    .then((res) => {
      if (res.data.code === 0) {
        return _.get(res, 'data.data.providers') || [];
      }
      return [];
    });
};

export const updateProviderSequence = (payload) => {
  return axios.put(`/cms/provider/bulk_update_sequence`, payload).then((res) => {
    if (res.data.code === 0) {
      return _.get(res, 'data.data', null);
    }
  });
};

export const getProviderById = (id) => {
  return axios.get(`/cms/provider/${id}`).then((res) => {
    if (res.data.code === 0) {
      return _.get(res, 'data.data', null);
    }
  });
};

export const getProviderCredentialById = (id) => {
  return axios.get(`/cms/provider/${id}/credential`).then((res) => {
    if (res.data.code === 0) {
      return _.get(res, 'data.data', null);
    }
  });
};

export const updateProviderById = (id, payload) => {
  return axios.put(`/cms/provider/${id}`, payload).then((res) => {
    if (res.data.code === 0) {
      return _.get(res, 'data.data', null);
    }
  });
};

export const updateProviderCredentialById = async (id, payload) => {
  return await axios.put(`/cms/provider/${id}/credential`, payload);
};

export const getCatagoryProvider = (providerId) => {
  return axios.get(`/cms/provider/${providerId}`).then((res) => {
    if (res.data.code === 0) {
      return _.get(res, 'data.data.category', []);
    }
  });
};

export const getGameByProviderId = ({ providerId, limit, page, search_game, category }) => {
  return axios
    .get(`/cms/provider/${providerId}/game/list`, {
      params: { limit, page, search_game, category },
    })
    .then((res) => {
      if (res.data.code === 0) {
        return _.get(res, 'data.data', []);
      }
    });
};

export const getMaintenanceList = () => {
  return axios.get('/cms/maintenance/list').then((res) => {
    if (res.data.code === 0) {
      return _.get(res, 'data.data.maintenances', []);
    }
  });
};

export const createMaintenance = (payload) => {
  return axios.post(`/cms/maintenance`, payload).then((res) => res.data);
};

export const updateMaintenanceByMaintenanceID = (id, payload) => {
  return axios.put(`/cms/maintenance/${id}`, payload).then((res) => res.data);
};

export const allMaintenance = (is_active) => {
  return axios
    .post(`/cms/provider/maintenance/list/enabled`, { enabled: is_active })
    .then((res) => res.data);
};

export const changeBetLimit = (payload) => {
  return axios.post(`/cms/provider/default_bet_limit/change`, payload).then((res) => res.data);
};

export const updateProviderConfig = (providerId, payload) => {
  return axios.put(`/cms/provider/${providerId}/config`, payload);
};

export const getSortedGames = ({ providerId, category, sort_criteria }) => {
  const formData = new FormData();
  formData.append('category', category);
  formData.append('sort_criteria', sort_criteria);

  return axios.post(`/cms/provider/${providerId}/game/sort`, formData).then((res) => res.data);
};

export const exportGames = (providerId, gameIds = []) => {
  const formData = new FormData();
  gameIds.forEach((id) => formData.append('game_ids', id));

  return axios
    .post(`/cms/provider/${providerId}/game/export`, formData)
    .then((res) => res.data?.data?.url);
};

export const importGames = async (providerId, file) => {
  const formData = new FormData();
  formData.append('file', file);

  const res = await axios.post(`/cms/provider/${providerId}/game/import`, formData);
  return res.data.data; // assuming { game_syncs: [...] }
};

export const bulkUpdateGameFlags = (providerId, payload = {}) => {
  return axios
    .post(`/cms/provider/${providerId}/game/bulk_flag`, payload)
    .then((res) => res.data?.data);
};

export const getPlatformEnableProviderList = () => {
  return axios.get('/cms/provider/list_active').then((res) => {
    if (res.data.code === 0) {
      return _.get(res, 'data.data.providers', []);
    }
  });
};

export const updateProviderAffiliateSetting = (providerId, payload) => {
  return axios.put(`/cms/provider/${providerId}/affiliate_settings`, payload);
};
